import * as cache from '@/assets/js/cache'

const state = {
  msgList: {},
  notifyCount: 0,
  unReadMsg: {},
  token: cache.getToken(),
  user: {},
  memberExt: {},
  infoCompleteRate: 0,
  setting: {},
  citys: [],
  editAddress: {},
  register: {},
  forget: {},
  updatePhone: {},
  isCommunicate: false,
  collection: localStorage.collection,
  uploadFileMaxSize: localStorage.uploadFileMaxSize,
  likeMsg: {},
  walletMsg: {},
  commentMsg: {},
  followMsg: {},
  video: {},
  socialData: {},
  myPosition: {},
  uploadTask: [],
  product: {},
  order: {},
  userInfo: {},
  reward: {},
  readArticleList: [],
  phone: localStorage.phone || ''
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js